<script setup lang="ts">
const localePath = useLocalePath();
</script>

<template>
  <div class="relative my-32 px-6 lg:px-8 xl:my-48">
    <div
      class="absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2 transform-gpu justify-center overflow-hidden blur-3xl sm:bottom-0 sm:right-[calc(50%-6rem)] sm:top-auto sm:translate-y-0 sm:transform-gpu sm:justify-end"
      aria-hidden="true"
    >
      <div
        class="aspect-[1108/632] w-[69.25rem] flex-none bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-25"
        style="clip-path: polygon(73.6% 48.6%, 91.7% 88.5%, 100% 53.9%, 97.4% 18.1%, 92.5% 15.4%, 75.7% 36.3%, 55.3% 52.8%, 46.5% 50.9%, 45% 37.4%, 50.3% 13.1%, 21.3% 36.2%, 0.1% 0.1%, 5.4% 49.1%, 21.4% 36.4%, 58.9% 100%, 73.6% 48.6%)"
      />
    </div>
    <div class="mx-auto max-w-2xl text-center">
      <h2 class="font-serif text-4xl font-semibold text-gray-900 sm:text-5xl">
        {{ $t('endCta.title') }}
      </h2>
      <p class="mx-auto mt-6 max-w-xl text-pretty text-lg/8 text-gray-600">
        {{ $t('endCta.subtitle') }}
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-3">
        <UButton :to="localePath('/app')">
          {{ $t('common.createContract') }}
        </UButton>
        <UButton
          variant="link"
          :to="localePath('/contact')"
        >
          {{ $t('common.contactUs') }} <span aria-hidden="true">→</span>
        </UButton>
      </div>
    </div>
    <div
      class="absolute left-1/2 right-0 top-full -z-10 hidden -translate-y-1/2 transform-gpu overflow-hidden blur-3xl sm:block"
      aria-hidden="true"
    >
      <div
        class="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
        style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
      />
    </div>
  </div>
</template>
